import { GRAY_COLORS, SPACE, styled } from '../../lib/stitches'

// TODO: Expand modularity styling with variants
export const TextInput = styled('input', {
  border: `1px solid ${GRAY_COLORS.gray05}`,
  borderRadius: '$6',
  background: 'transparent',
  padding: `${SPACE[10]} 12px`,
  fontSize: '$14',
  lineHeight: '$20',
  outline: 'none',
  color: '$gray15',
  transition: 'all 100ms ease',
  marginBottom: '$4',
  '&:placeholder': {
    color: '$gray08'
  },
  '&:focus': {
    boxShadow: `0px 0px 0px ${SPACE[4]} ${GRAY_COLORS.gray03}`
  },
  '&:disabled': {
    color: '$gray08'
  }
})
